import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Card } from '../Card';
import * as styles from '../CardsQuestion/styles.css';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var CardsChoseQuestion = function CardsChoseQuestion(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles['cards'],
    children: props.cards.map(function (card) {
      return /*#__PURE__*/_createElement(Card, _objectSpread(_objectSpread({}, card), {}, {
        key: card.value,
        onClick: props.handleSelect,
        iconType: props.iconType,
        selected: props.value && props.value.includes(card.value),
        selectable: true
      }));
    })
  });
};
CardsChoseQuestion.displayName = 'CardsChoseQuestion';